import * as yup from "yup";

export const companyRequestSchema = yup.object().shape({
    company_name: yup.string().trim().required("Field is required"),
    company_url: yup.string().trim().required("Field is required"),
});
